// @flow
import React from "react"
import Page from "pages/_Page"
import MainFilter from "pages/_Page/MainFilter"
import SearchResults from "./SearchResults"

const SearchPage = () => (
  <Page filter={MainFilter}>
    <SearchResults />
  </Page>
)

export default SearchPage



// WEBPACK FOOTER //
// ./src/pages/Search/index.js